import React from "react";

import {
  Link,
  NavLink,
} from "react-router-dom";

import {
  motion,
} from "framer-motion";

import {
  FiExternalLink,
  FiX,
  FiChevronLeft,
  FiChevronRight,
} from "react-icons/fi";

import {
  logo,
  darkLogo,
} from "../../../assets";

import {
  useStateContext,
} from "../../../context/ContextProvider";

import {
  useTranslation,
} from "react-i18next";

import {
  AdminLinks,
} from "../../../constants";


function DashboardSideBar() {
  const {
    activeMenu,
    setActiveMenu,
    currentMode,
    screenSize,
    currentDir,
  } = useStateContext();

  const {
    t,
  } = useTranslation();


  const isRTL =
    currentDir === "rtl";


  const DirectionArrow =
    isRTL
      ? FiChevronLeft
      : FiChevronRight;


  /* =====================================
      CLOSE MOBILE SIDEBAR
  ====================================== */

  const handleLinkClick = () => {
    /*
     * مهم:
     * لا نغلق Sidebar في الكمبيوتر.
     */

    if (
      screenSize <= 900
    ) {
      setActiveMenu(false);
    }
  };


  return (
    <div
      className="
        relative

        flex
        flex-col

        h-full

        overflow-hidden

        border-e
        border-color-2/10
        dark:border-white/10

        bg-back-primery
        dark:bg-back-darksecondary

        shadow-[8px_0_40px_rgba(68,37,20,.08)]
      "
    >

      {/* =====================================
          DECORATION
      ====================================== */}

      <div
        className="
          absolute

          -top-32
          -start-28

          w-72
          h-72

          rounded-full

          bg-color-1/10

          blur-[90px]

          pointer-events-none
        "
      />


      {/* =====================================
          BRAND
      ====================================== */}

      <div
        className="
          relative

          flex

          min-h-[118px]

          items-center
          justify-between

          px-6

          border-b
          border-color-2/10
          dark:border-white/10
        "
      >

        <Link
          to="/"

          onClick={
            handleLinkClick
          }

          className="
            flex
            items-center

            gap-3
          "
        >

          <img
            src={
              currentMode ===
              "Light"
                ? logo
                : darkLogo
            }

            alt="Yaman"

            className="
              w-[90px]
              h-auto

              object-contain
            "
          />

        </Link>


        {/* Close Mobile */}

        <motion.button
          type="button"

          whileTap={{
            scale: 0.9,
          }}

          onClick={() =>
            setActiveMenu(false)
          }

          className="
            lg:hidden

            flex

            w-10
            h-10

            items-center
            justify-center

            rounded-full

            border
            border-color-1/20

            bg-color-1/10

            text-color-1

            transition-colors

            hover:bg-color-1
            hover:text-white
          "
        >
          <FiX />
        </motion.button>

      </div>


      {/* =====================================
          ADMIN LABEL
      ====================================== */}

      <div
        className="
          px-5
          pt-6
          pb-2
        "
      >

        <div
          className="
            relative

            overflow-hidden

            rounded-[1.4rem]

            bg-color-2

            p-4

            text-white
          "
        >

          <div
            className="
              absolute

              -top-10
              -end-10

              w-28
              h-28

              rounded-full

              bg-color-1/20

              blur-2xl
            "
          />


          <div
            className="
              relative
              z-10
            "
          >

            <span
              className="
                font-kufi
                text-[10px]

                text-color-1
              "
            >
              {t(
                "Yaman Restaurant"
              )}
            </span>


            <h3
              className="
                mt-1

                font-kufi
                font-semibold

                text-sm

                text-white
              "
            >
              {t(
                "Management Dashboard"
              )}
            </h3>


            <span
              className="
                block

                mt-2

                font-kufi
                text-[9px]

                text-white/45
              "
            >
              {t(
                "Restaurant control center"
              )}
            </span>

          </div>

        </div>

      </div>


      {/* =====================================
          NAVIGATION
      ====================================== */}

      <nav
        className="
          flex-1

          overflow-y-auto

          px-4
          py-4

          scrollbar-thin
        "
      >

        {AdminLinks.map(
          (
            section,
            sectionIndex
          ) => (

            <div
              key={
                section.title
              }

              className={
                sectionIndex > 0
                  ? "mt-7"
                  : ""
              }
            >

              {/* Section Title */}

              <div
                className="
                  flex
                  items-center

                  gap-3

                  px-3

                  mb-2
                "
              >

                <span
                  className="
                    w-5
                    h-[2px]

                    rounded-full

                    bg-color-1
                  "
                />


                <p
                  className="
                    font-kufi
                    font-semibold

                    text-[10px]

                    uppercase

                    tracking-wide

                    text-n-5
                    dark:text-white/35
                  "
                >
                  {t(
                    section.title
                  )}
                </p>

              </div>


              {/* Links */}

              <div
                className="
                  space-y-1
                "
              >

                {section.links.map(
                  (link) => (

                    <NavLink
                      key={
                        link.name
                      }

                      to={`/${link.linkSide}`}

                      onClick={
                        handleLinkClick
                      }

                      className={({
                        isActive,
                      }) => `
                        group

                        relative

                        flex

                        min-h-[48px]

                        items-center

                        gap-3

                        overflow-hidden

                        rounded-[1rem]

                        px-4

                        font-kufi
                        text-sm

                        transition-all
                        duration-300

                        ${
                          isActive
                            ? `
                              bg-color-1

                              text-white

                              shadow-[0_8px_25px_rgba(165,119,58,.22)]
                            `
                            : `
                              text-tcolor-4
                              dark:text-white/65

                              hover:bg-color-1/10
                              hover:text-color-1
                            `
                        }
                      `}
                    >

                      {({
                        isActive,
                      }) => (
                        <>

                          {/* Decorative */}

                          {isActive && (
                            <span
                              className="
                                absolute

                                -start-4

                                w-10
                                h-10

                                rounded-full

                                bg-white/10
                              "
                            />
                          )}


                          <span
                            className={`
                              relative
                              z-10

                              flex

                              w-7
                              h-7

                              shrink-0

                              items-center
                              justify-center

                              text-lg

                              ${
                                isActive
                                  ? "text-white"
                                  : "text-color-1"
                              }
                            `}
                          >
                            {
                              link.icon
                            }
                          </span>


                          <span
                            className="
                              relative
                              z-10

                              flex-1
                            "
                          >
                            {t(
                              link.name
                            )}
                          </span>


                          <DirectionArrow
                            size={13}

                            className={`
                              relative
                              z-10

                              transition-all
                              duration-300

                              ${
                                isActive
                                  ? "opacity-70"
                                  : `
                                    opacity-0
                                    group-hover:opacity-100
                                  `
                              }
                            `}
                          />

                        </>
                      )}

                    </NavLink>

                  )
                )}

              </div>

            </div>

          )
        )}

      </nav>


      {/* =====================================
          BOTTOM WEBSITE LINK
      ====================================== */}

      <div
        className="
          p-4

          border-t
          border-color-2/10
          dark:border-white/10
        "
      >

        <Link
          to="/"

          className="
            group

            flex

            min-h-[48px]

            items-center
            justify-between

            gap-3

            rounded-[1rem]

            border
            border-color-1/15

            bg-color-1/5

            px-4

            font-kufi
            text-xs

            text-tcolor-4
            dark:text-white/70

            transition-all

            hover:bg-color-1
            hover:text-white
          "
        >

          <span>
            {t(
              "View Restaurant Website"
            )}
          </span>


          <FiExternalLink
            className="
              text-color-1

              transition-colors

              group-hover:text-white
            "
          />

        </Link>

      </div>

    </div>
  );
}


export default DashboardSideBar;